export default "__VITE_ASSET__C435vhTF__"